// import React, { useState ,useEffect} from "react";
// import axios from "axios";
// import {
//   Button,
//   Box,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
// } from "@mui/material";
// import { useSelector } from "react-redux";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useNavigate } from "react-router-dom";



// function FileReaderComponent() {
//   const [open, setOpen] = useState(false);
//   const [fileContent, setFileContent] = useState("");
//   const [uploadStatus, setUploadStatus] = useState("");
//   const [fileTemplate, setFileTemplate] = useState("");
//   const [isUploading, setIsUploading] = useState(false);
//   const { user } = useSelector((state) => state.user);
//   const navigate = useNavigate();
//   const token = user.token;

//   const formattedContent = fileContent
//     .replace(/password1:/g, "<br />password1:")
//     .replace(/username2:/g, "<br />username2:")
//     .replace(/password2:/g, "<br />password2:")
//     .trim();

 
//     useEffect(() => {
//       if (localStorage.getItem("showToastError")) {
//         toast.error("ข้อมูลไม่ถูกต้อง ระบบสามารถเพิ่มได้สูงสุด 2 คนเท่านั้น");
//         localStorage.removeItem("showToastError");
//       } else if (localStorage.getItem("showToastErrorrrr")) {
//         toast.error("กรุณาอัปโหลดไฟล์ชื่อ createuser.txt");
//         localStorage.removeItem("showToastErrorrrr");
//       } else if (localStorage.getItem("showToastValidationError")) {
//         toast.error("รูปแบบไฟล์ไม่ถูกต้อง! username1 ต้องมี password1 และ username2 ต้องมี password2");
//         localStorage.removeItem("showToastValidationError");
//       } else if (localStorage.getItem("showToastDuplicateUserError")) {
//         toast.error("username1 และ username2 ต้องไม่เหมือนกัน!");
//         localStorage.removeItem("showToastDuplicateUserError");
//       } else if (localStorage.getItem("showToastDuplicatePassError")) {
//         toast.error("password1 และ password2 ต้องไม่เหมือนกัน!");
//         localStorage.removeItem("showToastDuplicatePassError");
//       }
//     }, []);
    

  
  
  
//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
  
//     if (file && file.name === "createuser.txt") {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         const content = e.target.result;
//         const lines = content.split("\n").map(line => line.trim());
  
//         // ตรวจสอบจำนวนบรรทัดไม่เกิน 5
//         if (lines.length > 5) {
//           localStorage.setItem("showToastError", "true");
//           navigate(0);
//           return;
//         }
  
//         // ดึงค่าของ username1, password1, username2, password2
//         const getValue = (prefix) => {
//           const line = lines.find(line => line.startsWith(prefix));
//           return line ? line.split(":")[1].trim() : null;
//         };
  
//         const username1 = getValue("username1:");
//         const password1 = getValue("password1:");
//         const username2 = getValue("username2:");
//         const password2 = getValue("password2:");
  
//         // ตรวจสอบว่า username1 -> password1 และ username2 -> password2
//         if ((username1 && !password1) || (!username1 && password1) ||
//             (username2 && !password2) || (!username2 && password2)) {
//           localStorage.setItem("showToastValidationError", "true");
//           navigate(0);
//           return;
//         }
  
//         // ตรวจสอบ username1 ไม่ซ้ำกับ username2 และ password1 ไม่ซ้ำกับ password2
//         if (username1 && username2 && username1 === username2) {
//           localStorage.setItem("showToastDuplicateUserError", "true");
//           navigate(0);
//           return;
//         }
  
//         if (password1 && password2 && password1 === password2) {
//           localStorage.setItem("showToastDuplicatePassError", "true");
//           navigate(0);
//           return;
//         }
  
//         setFileContent(content);
//         setOpen(true);
//       };
//       reader.readAsText(file);
//       setFileTemplate(file);
//     } else {
//       localStorage.setItem("showToastErrorrrr", "true");
//       navigate(0);
//     }
//   };
  

//   const handleFileUpload = async () => {
//     if (!fileContent) {
//       setUploadStatus("ยังไม่ได้เลือกไฟล์");
//       return;
//     }

//     const renamedFile = new File([fileTemplate], "createuser.txt", {
//       type: fileTemplate.type,
//     });

//     const formData = new FormData();
//     formData.append("file", renamedFile);

//     try {
//       setIsUploading(true); // Start showing loader
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/uploadtxt`,
//         formData,
//         {
//           headers: {
//             authtoken: `bearer ${token}`,
//           },
//         }
//       );

//       if (response.status === 200) {
//         toast.success("อัปโหลดสำเร็จ");
//         setTimeout(() => {
//           navigate(0); 
//         }, 1000); // Optional delay before reload
//       }
//     } catch (error) {
//       setUploadStatus("เกิดข้อผิดพลาดขณะอัปโหลด");
//       console.error(error);
//     } finally {
//       setIsUploading(false); // Stop showing loader
//       setOpen(false);
//     }
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   return (
//     <Box sx={{ margin: "20px" }}>
//       <input
//         type="file"
//         accept=".txt"
//         onChange={handleFileChange}
//         style={{ display: "none" }}
//         id="file-upload"
//       />
//       <label htmlFor="file-upload">
//         <Button variant="contained" component="span">
//           อัปโหลดไฟล์ createuser.txt
//         </Button>
//       </label>
//       {fileContent && (
//         <Dialog
//           open={open}
//           onClose={handleClose}
//           aria-labelledby="alert-dialog-title"
//           aria-describedby="alert-dialog-description"
//         >
//           <DialogTitle id="alert-dialog-title">{"เนื้อหาในไฟล์: "}</DialogTitle>
//           <DialogContent>
//             <DialogContentText id="alert-dialog-description" component="div">
//               <div dangerouslySetInnerHTML={{ __html: formattedContent }} />
//             </DialogContentText>
//           </DialogContent>
//           <DialogActions>
//             {fileTemplate === "" ? (
//               ""
//             ) : (
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={handleFileUpload}
//                 sx={{ mt: 3 }}
//               >
//                 ตกลง
//               </Button>
//             )}
//           </DialogActions>
//         </Dialog>
//       )}
//       <ToastContainer />
//     </Box>
//   );
// }

// export default FileReaderComponent;



import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

function FileReaderComponent() {
  const [open, setOpen] = useState(false);
  const [fileContent, setFileContent] = useState("");
  const [uploadStatus, setUploadStatus] = useState("");
  const [fileTemplate, setFileTemplate] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const { user } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const token = user.token;

  const formattedContent = fileContent
    .replace(/password1:/g, "<br />password1:")
    .replace(/username2:/g, "<br />username2:")
    .replace(/password2:/g, "<br />password2:")
    .trim();

  useEffect(() => {
    if (localStorage.getItem("showToastError")) {
      toast.error("ข้อมูลไม่ถูกต้อง ระบบสามารถเพิ่มได้สูงสุด 2 คนเท่านั้น");
      localStorage.removeItem("showToastError");
    } else if (localStorage.getItem("showToastErrorrrr")) {
      toast.error("กรุณาอัปโหลดไฟล์ชื่อ createuser.txt");
      localStorage.removeItem("showToastErrorrrr");
    } else if (localStorage.getItem("showToastValidationError")) {
      toast.error("รูปแบบไฟล์ไม่ถูกต้อง! username1 ต้องมี password1 และ username2 ต้องมี password2");
      localStorage.removeItem("showToastValidationError");
    } else if (localStorage.getItem("showToastDuplicateUserError")) {
      toast.error("username1 และ username2 ต้องไม่เหมือนกัน!");
      localStorage.removeItem("showToastDuplicateUserError");
    } else if (localStorage.getItem("showToastDuplicatePassError")) {
      toast.error("password1 และ password2 ต้องไม่เหมือนกัน!");
      localStorage.removeItem("showToastDuplicatePassError");
    } else if (localStorage.getItem("showToastLineError")) {
      toast.error("ข้อมูลไม่ถูกต้อง ระบบสามารถเพิ่มได้สูงสุด 2 คนเท่านั้น");
      localStorage.removeItem("showToastLineError");
    }
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file && file.name === "createuser.txt") {
      const reader = new FileReader();
      reader.onload = (e) => {
        const content = e.target.result;
        const lines = content.split("\n").map(line => line.trim()).filter(line => line !== ""); 

        // ตรวจสอบจำนวนบรรทัดไม่เกิน 4
        if (lines.length > 4) {
          localStorage.setItem("showToastLineError", "true");
          navigate(0); // รีเฟรชหน้า
          return;
        }

        // ดึงค่าของ username1, password1, username2, password2
        const getValue = (prefix) => {
          const line = lines.find(line => line.startsWith(prefix));
          return line ? line.split(":")[1].trim() : null;
        };

        const username1 = getValue("username1:");
        const password1 = getValue("password1:");
        const username2 = getValue("username2:");
        const password2 = getValue("password2:");

        // ตรวจสอบว่า username1 -> password1 และ username2 -> password2
        if ((username1 && !password1) || (!username1 && password1) ||
            (username2 && !password2) || (!username2 && password2)) {
          localStorage.setItem("showToastValidationError", "true");
          navigate(0);
          return;
        }

        // ตรวจสอบ username1 ไม่ซ้ำกับ username2 และ password1 ไม่ซ้ำกับ password2
        if (username1 && username2 && username1 === username2) {
          localStorage.setItem("showToastDuplicateUserError", "true");
          navigate(0);
          return;
        }

        if (password1 && password2 && password1 === password2) {
          localStorage.setItem("showToastDuplicatePassError", "true");
          navigate(0);
          return;
        }

        setFileContent(content);
        setOpen(true);
      };
      reader.readAsText(file);
      setFileTemplate(file);
    } else {
      localStorage.setItem("showToastErrorrrr", "true");
      navigate(0);
    }
  };

  const handleFileUpload = async () => {
    if (!fileContent) {
      setUploadStatus("ยังไม่ได้เลือกไฟล์");
      return;
    }

    const renamedFile = new File([fileTemplate], "createuser.txt", {
      type: fileTemplate.type,
    });

    const formData = new FormData();
    formData.append("file", renamedFile);

    try {
      setIsUploading(true); // Start showing loader
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/uploadtxt`,
        formData,
        {
          headers: {
            authtoken: `bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("อัปโหลดสำเร็จ");
        setTimeout(() => {
          navigate(0); 
        }, 1000); // Optional delay before reload
      }
    } catch (error) {
      setUploadStatus("เกิดข้อผิดพลาดขณะอัปโหลด");
      console.error(error);
    } finally {
      setIsUploading(false); // Stop showing loader
      setOpen(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ margin: "20px" }}>
      <input
        type="file"
        accept=".txt"
        onChange={handleFileChange}
        style={{ display: "none" }}
        id="file-upload"
      />
      <label htmlFor="file-upload">
        <Button variant="contained" component="span">
          อัปโหลดไฟล์ createuser.txt
        </Button>
      </label>
      {fileContent && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"เนื้อหาในไฟล์: "}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" component="div">
              <div dangerouslySetInnerHTML={{ __html: formattedContent }} />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {fileTemplate === "" ? (
              ""
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={handleFileUpload}
                sx={{ mt: 3 }}
              >
                ตกลง
              </Button>
            )}
          </DialogActions>
        </Dialog>
      )}
      <ToastContainer />
    </Box>
  );
}

export default FileReaderComponent;
